/**
 * DataTables 行の textContent が列境界で食い込まないよう、
 * 中身のあるセル同士のあいだ（前セル末尾）へ visually-hidden の中黒を入れる。
 * 次セル先頭に置くと、セル単体が `· Freezer-A` / `· 残 · n` になり見出し監査で誤検出される。
 */
export function injectDataTableCellSeparators(row: HTMLElement): void {
  const cells = [...row.querySelectorAll(':scope > td')];
  let prevContent: HTMLElement | null = null;

  for (const td of cells) {
    // 旧実装（先頭 sep）が残っていれば末尾へ移す
    const leadingSep = td.querySelector(':scope > .dt-cell-sep:first-child');
    if (leadingSep && td.firstElementChild === leadingSep) {
      leadingSep.remove();
    }

    const textLen = (td.textContent || '').replace(/\s+/g, '').length;
    if (textLen === 0) continue;

    if (prevContent && !prevContent.querySelector(':scope > .dt-cell-sep')) {
      const sep = document.createElement('span');
      sep.className = 'visually-hidden dt-cell-sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = ' · ';
      prevContent.appendChild(sep);
    }
    prevContent = td;
  }
}
